'use client';

import Icon from '@/components/ui/AppIcon';

export default function OfficeLocationSection() {
  const officeDetails = [
  {
    id: 'office_address',
    icon: 'MapPinIcon',
    title: 'Postal Address',
    value: 'P.O. Box 153404',
    subtitle: 'Mukono, Uganda'
  },
  {
    id: 'office_region',
    icon: 'GlobeAltIcon',
    title: 'Service Region',
    value: 'Uganda',
    subtitle: 'Nationwide Distribution'
  },
  {
    id: 'office_network',
    icon: 'BuildingStorefrontIcon',
    title: 'Distribution Network',
    value: '250+ Farmers',
    subtitle: 'Growing Community'
  }];


  return (
    <section className="py-section px-6 bg-secondary">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 reveal">
          <p className="text-primary font-bold uppercase tracking-wider text-sm mb-4">Visit Us</p>
          <h2 className="text-heading-2 md:text-[3rem] lg:text-heading-1 leading-tight text-foreground mb-6">
            Office <span className="gradient-text">Location</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Find us in Mukono, Uganda, serving poultry farmers nationwide with premium Dutch-quality nutrition.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="glass-card rounded-2xl p-8 reveal">
              <h3 className="text-heading-3 text-foreground mb-6">Office Information</h3>
              <div className="space-y-6">
                {officeDetails?.map((detail, index) =>
                <div key={detail?.id} className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl green-gradient flex items-center justify-center flex-shrink-0">
                      <Icon name={detail?.icon} size={24} className="text-white" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-muted-foreground mb-1">{detail?.title}</p>
                      <p className="text-xl font-bold text-foreground">{detail?.value}</p>
                      <p className="text-sm text-muted-foreground">{detail?.subtitle}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="glass-card rounded-2xl p-8 reveal" style={{ animationDelay: '0.1s' }}>
              <h3 className="text-heading-3 text-foreground mb-6">Quick Contact</h3>
              <div className="space-y-4">
                <a href="tel:0777014115" className="flex items-center gap-3 p-4 bg-white rounded-xl hover:bg-green-50 transition-colors">
                  <Icon name="PhoneIcon" size={20} className="text-primary" />
                  <span className="text-lg font-semibold text-foreground">0777 014 115</span>
                </a>
                <a href="tel:0704846600" className="flex items-center gap-3 p-4 bg-white rounded-xl hover:bg-green-50 transition-colors">
                  <Icon name="PhoneIcon" size={20} className="text-primary" />
                  <span className="text-lg font-semibold text-foreground">0704 846 600</span>
                </a>
                <a href="mailto:info@bloomanimalfeeds.com" className="flex items-center gap-3 p-4 bg-white rounded-xl hover:bg-green-50 transition-colors">
                  <Icon name="EnvelopeIcon" size={20} className="text-primary" />
                  <span className="text-lg font-semibold text-foreground">info@bloomanimalfeeds.com</span>
                </a>
              </div>
            </div>
          </div>

          <div className="glass-card rounded-2xl p-8 reveal" style={{ animationDelay: '0.2s' }}>
            <h3 className="text-heading-3 text-foreground mb-6">Location Map</h3>
            <div className="relative rounded-xl overflow-hidden shadow-lg mb-6">
              <div className="aspect-[4/3] bg-gradient-to-br from-green-100 via-green-50 to-white">
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_10f2fb28f-1767639138454.png"
                  alt="Broiler chickens in Uganda poultry farm showing healthy growth"
                  className="w-full h-full object-cover" />
                
              </div>
            </div>
            <div className="mt-6 p-4 bg-green-50 rounded-xl border border-primary/20">
              <div className="flex items-start gap-3">
                <Icon name="TruckIcon" size={24} className="text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-foreground mb-1">Nationwide Delivery Available</p>
                  <p className="text-sm text-muted-foreground">
                    We work with trusted distributors across Uganda to ensure our premium feed concentrates reach your farm.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 glass-card rounded-2xl p-8 md:p-12 text-center reveal" style={{ animationDelay: '0.3s' }}>
          <div className="relative rounded-2xl overflow-hidden shadow-xl mb-8">
            <div className="aspect-[21/9] bg-gradient-to-br from-green-100 to-green-50">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_17bb78f5f-1766982532254.png"
                alt="Healthy broiler chickens in clean farm environment showing optimal growth and development"
                className="w-full h-full object-cover" />
              
            </div>
          </div>
          <h3 className="text-heading-3 text-foreground mb-4">Ready to Partner With Us?</h3>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Whether you're looking for premium feed solutions or interested in becoming a distributor, we're here to support your success.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href="#inquiry-form" className="green-gradient text-white font-bold py-4 px-8 rounded-xl hover:shadow-lg hover:scale-105 transition-all">
              Send an Inquiry
            </a>
            <a href="#distributor-form" className="glass-card text-primary font-bold py-4 px-8 rounded-xl hover:scale-105 transition-all">
              Apply as Distributor
            </a>
          </div>
        </div>
      </div>
    </section>);

}